export default function getSelectedVin(serverContext: any) {
    const selectedVin =
        serverContext.webviewData?.vin ||
        window.sessionStorage.getItem('selectedVin');

    return selectedVin;
}
